import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {StudiewijzerlinkjesNewFacade} from '../../state/studiewijzerlinkjes/studiewijzerlinkjes.facade';

@Component({
  selector: 'app-studiewijzerlinkjes-table-row',
  templateUrl: './studiewijzerlinkjes-table-row.component.html',
  styleUrls: ['./studiewijzerlinkjes-table-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudiewijzerlinkjesTableRowComponent implements OnInit {

  constructor(store: StudiewijzerlinkjesNewFacade) { }

  ngOnInit(): void {
  }

}
